import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { useSetState } from "Helpers/Hooks";
import { useTranslation } from "react-i18next";
import Input from "Components/Input/Input";
import ListProjects from "./list";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import SelectedProjectUnits from "./SelectedProject";
import NewProject from "./New";

export default function Projects() {
  const { t } = useTranslation();
  const [doSearch, setDoSearch] = useState("CLEARSEARCH");
  const [controls, setControls] = useSetState({
    nameSearch: {
      type: "search",
      value: null,
      row: 2,
      validation: null,
      col: 3,
    },
  });

  const setValue = async (name, value, validation) => {
    setControls({ [name]: { value: value } });
  };

  const onSearch = async (e) => {
    e.preventDefault();
    setDoSearch("DOSEARCH");
  };

  const onClearSearch = async (e) => {
    e.preventDefault();
    setControls({ nameSearch: { value: "" } });
    setDoSearch("CLEARSEARCH");
  };

  const onDone = () => {
    setDoSearch("PENDING");
  };

  return (
    <>
      <MuiPaper>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Input
              setValue={setValue.bind(this)}
              name="nameSearch"
              value={controls.nameSearch.value ? controls.nameSearch.value : ""}
              placeholder={t("nameSearch")}
              type="search"
              onSearch={onSearch}
              onClearSearch={onClearSearch}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={8}
            className="d-flex justify-content-end mt-1"
          >
            <NewProject />
          </Grid>
          <Grid item xs={12}>
            <ListProjects
              nameSearch={controls.nameSearch.value}
              doSearch={doSearch}
              done={onDone}
            />
          </Grid>
        </Grid>
      </MuiPaper>

      <SelectedProjectUnits />
    </>
  );
}
